import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-xl text-white mb-4">🍌 香蕉视频</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                创意短视频平台，记录精彩生活，发现更多乐趣。与千万创作者一起，分享每一个美好瞬间。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-300 transition-colors">首页</Link></li>
                <li><Link to="/category/搞笑" className="text-sm text-background-400 hover:text-primary-300 transition-colors">内容分类</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-300 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/搞笑" className="text-sm text-background-400 hover:text-primary-300 transition-colors">搞笑日常</Link></li>
                <li><Link to="/category/美食" className="text-sm text-background-400 hover:text-primary-300 transition-colors">美食制作</Link></li>
                <li><Link to="/category/音乐" className="text-sm text-background-400 hover:text-primary-300 transition-colors">音乐舞蹈</Link></li>
                <li><Link to="/category/旅行" className="text-sm text-background-400 hover:text-primary-300 transition-colors">旅行风光</Link></li>
                <li><Link to="/category/科技" className="text-sm text-background-400 hover:text-primary-300 transition-colors">科技数码</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@xiangjiaotv.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区创意产业园</span>
                </li>
              </ul>
              <div className="flex gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="B站">
                  <i className="ri-bilibili-line text-white text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 香蕉视频 XiangJiaoTV. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="#" className="hover:text-primary-300 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-primary-300 transition-colors">用户协议</a>
              <a href="#" className="hover:text-primary-300 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}